import { VehicleDto } from '@fleet-beat/api';

export interface BulkEditLogsBody {
  truck?: VehicleDto;
  shippingDocument?: string;
  trailerNumber?: string;
  isLocked?: boolean;
}
